import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Loader2, KeyRound } from "lucide-react";
import { qrtMe, qrtChangePassword } from "../../apis/qrtAdmin";
import { fmtDateTime } from "./qrtUi";

const QrtSettings = () => {
  const [me, setMe] = useState(null);
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    qrtMe().then((res) => setMe(res.data?.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 8) { toast.error("New password must be at least 8 characters"); return; }
    if (form.next !== form.confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await qrtChangePassword(form.current, form.next);
      toast.success("Password changed");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) {
      toast.error(err.response?.data?.error || "Failed to change password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <div className="qrt-page-head">
        <div>
          <h2>Settings</h2>
          <p>BluTec Ping admin account</p>
        </div>
      </div>

      {me && (
        <div className="qrt-card">
          <div className="qrt-card-head"><h3>Profile</h3></div>
          <div className="qrt-card-body" style={{ fontSize: 13.5, color: "var(--text-2)" }}>
            <p style={{ margin: "0 0 4px" }}><b style={{ color: "var(--text)" }}>{me.name}</b> · {me.email}</p>
            <p style={{ margin: 0 }}>
              Role: <b>{me.role}</b> · Last login: {fmtDateTime(me.last_login_at)} · Created: {fmtDateTime(me.created_at)}
            </p>
          </div>
        </div>
      )}

      <div className="qrt-card" style={{ maxWidth: 460 }}>
        <div className="qrt-card-head"><h3>Change password</h3></div>
        <form className="qrt-card-body qrt-form" onSubmit={submit}>
          <label>
            Current password
            <input type="password" value={form.current} autoComplete="current-password"
              onChange={(e) => setForm((f) => ({ ...f, current: e.target.value }))} required />
          </label>
          <label>
            New password (min 8 chars)
            <input type="password" value={form.next} autoComplete="new-password" minLength={8}
              onChange={(e) => setForm((f) => ({ ...f, next: e.target.value }))} required />
          </label>
          <label>
            Confirm new password
            <input type="password" value={form.confirm} autoComplete="new-password"
              onChange={(e) => setForm((f) => ({ ...f, confirm: e.target.value }))} required />
          </label>
          <button type="submit" className="ping-btn ping-btn-green" disabled={busy} style={{ alignSelf: "flex-start" }}>
            {busy ? <Loader2 size={15} className="animate-spin" /> : <KeyRound size={15} />}
            Change password
          </button>
        </form>
      </div>
    </div>
  );
};

export default QrtSettings;
